import { type Department, tr } from "../../engine";
import { GS1 } from "./l1-ward";
import { GS2 } from "./l2-er";
import { GS3 } from "./l3-opd";
import { GS4 } from "./l4-night";
import { GS5 } from "./l5-or";

/** Design notes: docs/gs-rotation.md. */
export const GS: Department = {
  id: "gs",
  name: tr("一般外科", "General Surgery"),
  tagline: tr(
    "肝膽胰、胃腸、疝氣。五個關卡，同一群人，同一個月",
    "HPB, upper GI and bowel, hernias. Five levels, one team, one month",
  ),
  attending: "gs_vs",
  attendingDialog: "vs",
  grader: tr("一般外科主治醫師", "a general surgery attending"),
  note: tr(
    "建議照順序玩：第一關是教學關；第三關的病人會在第五關開刀。",
    "Best played in order: Level 1 is the tutorial, and the patient from Level 3 comes back for surgery in Level 5.",
  ),
  levels: [GS1, GS2, GS3, GS4, GS5],
};
